(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["blog-newsletter-klaviyo"] && !Shopify.designMode) return;
  try {
    (function() {
    "use strict";
    const form = document.getElementById("klaviyo-blog-newsletter");
    if (!form) return;
    const emailInput = form.querySelector('input[name="email"]');
    const consentCheckbox = form.querySelector('input[name="consent"]');
    const submitButton = form.querySelector(".blog-newsletter__button");
    const successMessage = form.querySelector(".blog-newsletter__message--success");
    const errorMessage = form.querySelector(".blog-newsletter__message--error");
    form.addEventListener("submit", function(e) {
        e.preventDefault();
        successMessage.classList.remove("show");
        errorMessage.classList.remove("show");
        if (!emailInput.value.trim() || !emailInput.validity.valid) {
            emailInput.focus();
            showError();
            return;
        }
        if (!consentCheckbox.checked) {
            consentCheckbox.focus();
            showError();
            return;
        }
        const submittingText = submitButton.getAttribute("data-submitting-text") || "Subscribing...";
        submitButton.disabled = true;
        submitButton.textContent = submittingText;
        const formData = new FormData(form);
        fetch(form.action, {
            method: "POST",
            body: formData,
            mode: "no-cors"
        }).then(function() {
            showSuccess();
            form.reset();
        }).catch(function(error) {
            console.error("Newsletter signup error:", error);
            showError();
        }).finally(function() {
            const submitText = submitButton.getAttribute("data-submit-text") || "Subscribe";
            submitButton.disabled = false;
            submitButton.textContent = submitText;
        });
    });
    function showSuccess() {
        successMessage.classList.add("show");
        setTimeout(function() {
            successMessage.classList.remove("show");
        }, 5e3);
    }
    function showError() {
        errorMessage.classList.add("show");
        setTimeout(function() {
            errorMessage.classList.remove("show");
        }, 5e3);
    }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["blog-search-enhanced"] && !Shopify.designMode) return;
  try {
    (function() {
    "use strict";
    const searchForm = document.querySelector(".blog-search-form");
    if (!searchForm) return;
    const searchInput = searchForm.querySelector(".blog-search-input");
    const categorySelect = searchForm.querySelector(".blog-search-category");
    const searchButton = searchForm.querySelector(".blog-search-button");
    searchForm.addEventListener("submit", function(e) {
        const searchQuery = searchInput.value.trim();
        const selectedCategory = categorySelect.value;
        if (!searchQuery && !selectedCategory) {
            e.preventDefault();
            searchInput.focus();
            return;
        }
        const searchingText = searchButton.getAttribute("data-searching-text");
        const originalText = searchButton.getAttribute("data-search-text");
        searchButton.textContent = searchingText;
        searchButton.disabled = true;
        setTimeout(() => {
            searchButton.textContent = originalText;
            searchButton.disabled = false;
        }, 3e3);
    });
    searchInput.addEventListener("keydown", function(e) {
        if (e.key === "Escape") {
            this.value = "";
            this.blur();
        }
    });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["blog-share-buttons"] && !Shopify.designMode) return;
  try {
    window.copyLinkToClipboard = function(url) {
    const messageEl = document.getElementById("share-copy-message");
    const linkCopiedText = messageEl ? messageEl.getAttribute("data-link-copied") : "Link copied!";
    if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(function() {
            showCopyMessage(linkCopiedText);
        }).catch(function(err) {
            fallbackCopyTextToClipboard(url);
        });
    } else {
        fallbackCopyTextToClipboard(url);
    }
};

function fallbackCopyTextToClipboard(text) {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    textArea.style.position = "fixed";
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.width = "2em";
    textArea.style.height = "2em";
    textArea.style.padding = "0";
    textArea.style.border = "none";
    textArea.style.outline = "none";
    textArea.style.boxShadow = "none";
    textArea.style.background = "transparent";
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    const messageEl = document.getElementById("share-copy-message");
    const linkCopiedText = messageEl ? messageEl.getAttribute("data-link-copied") : "Link copied!";
    const shareFailedText = messageEl ? messageEl.getAttribute("data-share-failed") : "Failed to copy";
    try {
        const successful = document.execCommand("copy");
        if (successful) {
            showCopyMessage(linkCopiedText);
        } else {
            showCopyMessage(shareFailedText);
        }
    } catch (err) {
        showCopyMessage(shareFailedText);
    }
    document.body.removeChild(textArea);
}

function showCopyMessage(message) {
    const messageEl = document.getElementById("share-copy-message");
    if (!messageEl) return;
    messageEl.textContent = message;
    messageEl.classList.add("show");
    setTimeout(function() {
        messageEl.classList.remove("show");
        setTimeout(function() {
            messageEl.textContent = "";
        }, 300);
    }, 3e3);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["clips-pdp-sticky-preview"] && !Shopify.designMode) return;
  try {
    (function() {
    "use strict";
    var mq = window.matchMedia("(max-width: 768px)");
    var activeSection = null;
    var immersive = false;
    var headerStack = 92;
    var io = null;
    var topSentinel = null, bottomSentinel = null;
    var topAbove = false, bottomAbove = false;
    function snapshotHeaderStack() {
        var ann = document.querySelector(".announcement-bar");
        var hdr = document.querySelector(".chemistrie-header");
        var h = (ann ? ann.offsetHeight : 0) + (hdr ? hdr.offsetHeight : 0);
        if (!h) {
            var v = parseFloat(getComputedStyle(document.body).getPropertyValue("--chemistrie-header-stack-height"));
            h = v || 92;
        }
        headerStack = h;
        document.documentElement.style.setProperty("--cps-hide-y", Math.round(h) + 4 + "px");
    }
    function setImmersive(next) {
        if (next === immersive) return;
        immersive = next;
        document.body.classList.toggle("cps-immersive", immersive);
    }
    function onIO(entries) {
        entries.forEach(function(e) {
            var above = e.boundingClientRect.top < headerStack;
            if (e.target === topSentinel) topAbove = above; else if (e.target === bottomSentinel) bottomAbove = above;
        });
        setImmersive(topAbove && !bottomAbove);
    }
    function buildObserver() {
        if (!activeSection || !topSentinel || !bottomSentinel) return;
        if (io) io.disconnect();
        io = new IntersectionObserver(onIO, {
            rootMargin: -Math.round(headerStack) + "px 0px 0px 0px",
            threshold: 0
        });
        io.observe(topSentinel);
        io.observe(bottomSentinel);
    }
    var resizeTO = null;
    function onResize() {
        clearTimeout(resizeTO);
        resizeTO = setTimeout(function() {
            snapshotHeaderStack();
            buildObserver();
        }, 250);
    }
    window.addEventListener("resize", onResize);
    window.addEventListener("orientationchange", function() {
        snapshotHeaderStack();
        buildObserver();
    });
    function eligible(section) {
        return !!section.querySelector(".pdp-color-picker");
    }
    function apply(section) {
        var ctrl = section.__cpsCtrl;
        if (ctrl && ctrl.applied) return;
        var container = section.querySelector(".clips-pdp-hero__container");
        var gallery = section.querySelector(".clips-pdp-hero__gallery");
        var details = section.querySelector(".clips-pdp-hero__details");
        if (!container || !gallery || !details) return;
        var picker = details.querySelector(":scope > .pdp-color-picker") || section.querySelector(".pdp-color-picker");
        if (!picker) return;
        var previewNodes = [ gallery ];
        var title = details.querySelector(":scope > .clips-pdp-hero__title");
        var price = details.querySelector(":scope > .clips-pdp-hero__price");
        if (title) previewNodes.push(title);
        if (price) previewNodes.push(price);
        details.querySelectorAll(":scope > .shopify-app-block").forEach(function(n) {
            previewNodes.push(n);
        });
        var flowNodes = [];
        details.querySelectorAll(":scope > .clips-pdp-hero__callout, :scope > .clips-pdp-hero__specs").forEach(function(n) {
            flowNodes.push(n);
        });
        flowNodes.push(picker);
        var scope = document.createElement("div");
        scope.className = "clips-pdp-hero__sticky-scope";
        var preview = document.createElement("div");
        preview.className = "clips-pdp-hero__sticky-preview";
        scope.appendChild(preview);
        var moves = [];
        function relocate(node, dest) {
            var placeholder = document.createComment("cps");
            node.parentNode.insertBefore(placeholder, node);
            moves.push({
                node: node,
                placeholder: placeholder
            });
            dest.appendChild(node);
        }
        previewNodes.forEach(function(n) {
            relocate(n, preview);
        });
        flowNodes.forEach(function(n) {
            relocate(n, scope);
        });
        container.insertBefore(scope, container.firstChild);
        section.classList.add("is-mobile-sticky");
        section.__cpsCtrl = {
            applied: true,
            scope: scope,
            moves: moves
        };
        activeSection = section;
        topSentinel = document.createElement("div");
        topSentinel.className = "cps-sentinel cps-sentinel--top";
        bottomSentinel = document.createElement("div");
        bottomSentinel.className = "cps-sentinel cps-sentinel--bottom";
        scope.insertBefore(topSentinel, scope.firstChild);
        scope.appendChild(bottomSentinel);
        snapshotHeaderStack();
        buildObserver();
        document.body.classList.add("cps-sticky-active");
    }
    function restore(section) {
        var ctrl = section.__cpsCtrl;
        if (!ctrl || !ctrl.applied) return;
        ctrl.moves.forEach(function(m) {
            if (m.placeholder.parentNode) {
                m.placeholder.parentNode.replaceChild(m.node, m.placeholder);
            }
        });
        if (ctrl.scope && ctrl.scope.parentNode) {
            ctrl.scope.parentNode.removeChild(ctrl.scope);
        }
        section.classList.remove("is-mobile-sticky");
        section.__cpsCtrl = {
            applied: false
        };
        if (io) {
            io.disconnect();
            io = null;
        }
        topSentinel = null;
        bottomSentinel = null;
        activeSection = null;
        immersive = false;
        topAbove = false;
        bottomAbove = false;
        document.body.classList.remove("cps-sticky-active", "cps-immersive");
    }
    function sync() {
        document.querySelectorAll(".clips-pdp-hero").forEach(function(section) {
            if (!eligible(section)) return;
            if (mq.matches) apply(section); else restore(section);
        });
    }
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", sync);
    } else {
        sync();
    }
    if (mq.addEventListener) mq.addEventListener("change", sync); else if (mq.addListener) mq.addListener(sync);
    document.addEventListener("shopify:section:load", sync);
    document.addEventListener("shopify:section:unload", function(e) {
        var section = e.target && e.target.querySelector ? e.target.querySelector(".clips-pdp-hero") : null;
        if (section) restore(section);
    });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["reorder-clip-modal"] && !Shopify.designMode) return;
  try {
    (function() {
    function getModal() {
        return document.getElementById("reorderClipModal");
    }
    function openReorderModal() {
        var modal = getModal();
        if (!modal) return;
        if (typeof window.closeAllHeaderElements === "function") {
            window.closeAllHeaderElements();
        }
        modal.style.display = "flex";
        document.body.style.overflow = "hidden";
        var closeBtn = document.getElementById("reorderModalClose");
        if (closeBtn) {
            setTimeout(function() {
                closeBtn.focus();
            }, 50);
        }
    }
    function closeReorderModal() {
        var modal = getModal();
        if (!modal) return;
        modal.style.display = "none";
        document.body.style.overflow = "";
    }
    function init() {
        var modal = getModal();
        if (!modal) return;
        document.querySelectorAll("[data-reorder-modal-open]").forEach(function(trigger) {
            trigger.addEventListener("click", function(e) {
                e.preventDefault();
                openReorderModal();
            });
        });
        var closeBtn = document.getElementById("reorderModalClose");
        if (closeBtn) closeBtn.addEventListener("click", closeReorderModal);
        modal.addEventListener("click", function(e) {
            if (e.target === modal) closeReorderModal();
        });
        document.addEventListener("keydown", function(e) {
            if (e.key === "Escape" && modal.style.display === "flex") closeReorderModal();
        });
        var retailBtn = document.getElementById("reorderCustomizeClipBtn");
        if (retailBtn) {
            retailBtn.addEventListener("click", function() {
                window.location.href = "/pages/order-flow?reorder=1&start=retail";
            });
        }
    }
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", init);
    } else {
        init();
    }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["shop-pay-installments"] && !Shopify.designMode) return;
  try {
    (function () {
    var sharedSheet = null;
    function themeSheet() {
      if (sharedSheet !== null) return sharedSheet;
      try {
        var s = new CSSStyleSheet();
        s.replaceSync('#shopify-installments, #shopify-installments * { font-family: inherit !important; }');
        sharedSheet = s;
      } catch (e) {
        sharedSheet = false;
      }
      return sharedSheet;
    }
    function relabelTrigger(root) {
      /* Normalize the banner's modal-trigger wording to "Learn more" (Shop Pay shows
         "View sample plans" on some banners, "Learn more" on others). Relabel only the
         text node so any icon and the click handler are preserved and the popup still
         works. Returns true once the trigger link is present, so polling can stop. */
      var nodes = root.querySelectorAll('a, button, [role="button"]');
      var found = false;
      for (var i = 0; i < nodes.length; i++) {
        var n = nodes[i];
        var t = (n.textContent || '').trim().toLowerCase();
        if (t.indexOf('sample plan') === -1 && t.indexOf('learn more') === -1) continue;
        found = true;
        if (t.indexOf('sample plan') !== -1) {
          var w = document.createTreeWalker(n, NodeFilter.SHOW_TEXT, null);
          var tn;
          while ((tn = w.nextNode())) {
            if (/sample plan/i.test(tn.nodeValue)) {
              tn.nodeValue = tn.nodeValue
                .replace(/view\s+sample\s+plans?\.?/ig, 'Learn more')
                .replace(/sample\s+plans?\.?/ig, 'Learn more');
            }
          }
        }
      }
      return found;
    }
    function applyThemeFont() {
      var banners = document.querySelectorAll('shopify-payment-terms');
      var pending = false;
      banners.forEach(function (el) {
        var root = el.shadowRoot;
        if (!root) { pending = true; return; }
        if (!el.__themeFontApplied) {
          var s = themeSheet();
          if (s) {
            try {
              root.adoptedStyleSheets = Array.prototype.slice.call(root.adoptedStyleSheets).concat(s);
            } catch (e) {}
          }
          el.__themeFontApplied = true;
        }
        if (!el.__lmDone) {
          if (relabelTrigger(root)) el.__lmDone = true;
          else pending = true;
        }
      });
      return banners.length > 0 && !pending;
    }
    function watch() {
      if (applyThemeFont()) return;
      var observer = new MutationObserver(function () {
        if (applyThemeFont()) observer.disconnect();
      });
      observer.observe(document.documentElement, { childList: true, subtree: true });
      var tries = 0;
      var timer = setInterval(function () {
        if (applyThemeFont() || ++tries > 20) {
          clearInterval(timer);
          observer.disconnect();
        }
      }, 250);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', watch);
    } else {
      watch();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
